import { render } from "./LoadingForAuthentication.vue?vue&type=template&id=6c58b4b8&scoped=true&ts=true"
import script from "./LoadingForAuthentication.vue?vue&type=script&lang=ts"
export * from "./LoadingForAuthentication.vue?vue&type=script&lang=ts"

import "./LoadingForAuthentication.vue?vue&type=style&index=0&id=6c58b4b8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c58b4b8"]])

export default __exports__